// @ts-nocheck

import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/SYS_USER',
    name: 'SYS_USER',
    component: () => import(/* webpackChunkName: "sys_user" */ './views/sys_user/sys_user.vue')
  },
  {
    path: '/SYS_JOB',
    name: 'SYS_JOB',
    component: () => import(/* webpackChunkName: "sys_job" */'./views/sys_job/sys_job.vue')
  },
  {
    path: '/SYS_DEPT',
    name: 'SYS_DEPT',
    component: () => import(/* webpackChunkName: "sys_dept" */'./views/sys_dept/sys_dept.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

const mapping_Name_To_Title={
    "SYS_USER":"员工账户",
    "SYS_JOB":"部门管理",
    "SYS_DEPT":"职务管理",
}

export {
    router,
    mapping_Name_To_Title
}
